/**
 * Copyright © Veeam Software Group GmbH.
 */
import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { DataBackupObjectStorage } from './components';

export const ProtectedDataDataBackupObjectStoragePage: React.FC<{}> = () => (
    <TabBarBodyLayout>
        <DataBackupObjectStorage />
    </TabBarBodyLayout>
);
